var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.857 26.875c6.628 0 12-5.374 12-12.003 0-6.628-5.372-12.002-12-12.002-6.627 0-12 5.374-12 12.002 0 6.63 5.373 12.003 12 12.003z",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.857 17.22a2.347 2.347 0 100-4.694 2.347 2.347 0 000 4.695z",
    stroke: "#E84",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.394 13.056a4.91 4.91 0 00.088 3.041 1.893 1.893 0 002.385.947 2.17 2.17 0 001.262-2.171 6.21 6.21 0 00-7.42-6.09 6.207 6.207 0 00-4.524 8.466 6.209 6.209 0 005.736 3.833c.804 0 1.6-.154 2.347-.454",
    stroke: "#E84",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.536 23.536l5.607 5.594",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
export default SvgFindEmail;